import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import IconBase from '../icons/IconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LogoSquare = function LogoSquare(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 48 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 48 : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(IconBase, _objectSpread(_objectSpread({
    viewBox: "0 0 48 48"
  }, props), {}, {
    $styles: _objectSpread({
      width: width,
      height: height
    }, (props === null || props === void 0 ? void 0 : props.$styles) || {}),
    children: [/*#__PURE__*/_jsx("rect", {
      width: "48",
      height: "48",
      rx: "10.4",
      fill: "#FFD02F"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.3415 6H28.0732L32.4634 13.7143L22.8049 6H17.5366L22.3659 15.4286L12.2683 6H7L12.2683 18L7 42H12.2683L22.3659 16.2857L17.5366 42H22.8049L32.4634 14.5714L28.0732 42H33.3415L43 12L33.3415 6Z",
      fill: "#050038"
    })]
  }));
};

export default LogoSquare;